// extracted by mini-css-extract-plugin
export default {"checkbox":"styles_checkbox__ka+Kc","checkboxActive":"styles_checkboxActive__oYx75"};